/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
    TournamentToJSONTyped,
} from './Tournament';

/**
 * Result of duplicating a tournament
 * @export
 * @interface TournamentDuplicateResponse
 */
export interface TournamentDuplicateResponse {
    /**
     * 
     * @type {Tournament}
     * @memberof TournamentDuplicateResponse
     */
    tournament: Tournament;
    /**
     * 
     * @type {string}
     * @memberof TournamentDuplicateResponse
     */
    message: string;
}

/**
 * Check if a given object implements the TournamentDuplicateResponse interface.
 */
export function instanceOfTournamentDuplicateResponse(value: object): value is TournamentDuplicateResponse {
    if (!('tournament' in value) || value['tournament'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TournamentDuplicateResponseFromJSON(json: any): TournamentDuplicateResponse {
    return TournamentDuplicateResponseFromJSONTyped(json, false);
}

export function TournamentDuplicateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentDuplicateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': TournamentFromJSON(json['tournament']),
        'message': json['message'],
    };
}

export function TournamentDuplicateResponseToJSON(json: any): TournamentDuplicateResponse {
    return TournamentDuplicateResponseToJSONTyped(json, false);
}

export function TournamentDuplicateResponseToJSONTyped(value?: TournamentDuplicateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': TournamentToJSON(value['tournament']),
        'message': value['message'],
    };
}

